import React, { ReactNode } from "react";
import Link from "next/link";
import { Button } from "@/v2-components/ui/button";
import Loading from "@/common/Loading";
import dynamic from "next/dynamic";
import { SUPPORT_HUB_URL } from "@/constants/Urls.ts";
import { useTrans } from "@/utils/useTrans";

/**
 * FAQ 태그. 컨텐츠는 content/faq/product/{slug}/meta.json 의 tags 와 매칭됨.
 * (과거 Notion DB 의 multi-select 와 동일한 키 유지 — 외부 /api/faq 호환)
 */
export enum FaqNotionTags {
  AllProduct = "all-product",
  TactSuitPro = "tactsuit-pro",
  TactSuitAir = "tactsuit-air",
  TactocyForFeet = "tactocy-for-feet",
  TactGlove = "tactglove",
  FpsBundle = "fps-bundle",
  StarterBundle = "starter-bundle",
  ExoshockBundle = "exoshock-bundle",
  Developer = "developer",
  GameSelling = "game-selling",
  AudioToHaptics = "audio-to-haptics",
  BetaPCP = "beta-pcp",
  BetaVRP = "beta-vrp",
}

const DynamicFaqContents = dynamic(() => import("./BhapticsFaqContents"), {
  ssr: false,
  loading: () => <Loading className="py-10" full={false} />,
});

const BhapticsFaqSection = ({
  tag,
  contents,
  className,
}: {
  tag: FaqNotionTags | FaqNotionTags[];
  contents?: ReactNode;
  className?: string;
}) => {
  return (
    <DynamicFaqContents contents={contents} tag={tag} className={className} />
  );
};

export default BhapticsFaqSection;

export const FaqHelp = () => {
  const { t } = useTrans(["support"]);
  return (
    <div className="flex w-full items-center justify-between gap-2 border-t border-coolgray-20 pt-7">
      <p className="text-lg font-500">{t("Still need help?")}</p>

      <Link href={SUPPORT_HUB_URL.newTicket} target="_blank">
        <Button
          variant="darkgray-fill"
          size="sm"
          shape="pill"
          className="px-6 py-3"
        >
          {t("Contact Support")}
        </Button>
      </Link>
    </div>
  );
};
